(() => {
  // Bug fix (2026-09-01): this guard was disabling "Agregar al carrito" and
  // "Comprar ahora" on EVERY product, for two reasons:
  //   1) It had no product-id check, so it ran on all product forms instead
  //      of only the one product it was meant for — Carla | Vestido maxi
  //      asimétrico estampado (product.id 10970661093713), per the comment
  //      in snippets/scripts.liquid.
  //   2) hasSelection() only recognized a native `input[type="radio"]:checked`,
  //      but this theme renders size options through the Swatch King app,
  //      which uses `<li role="radio" aria-checked="true">` list items
  //      instead of native radio inputs — so the check never matched and
  //      the buttons stayed disabled forever, for every product.
  const RESTRICTED_PRODUCT_ID = '10970661093713'; // Carla | Vestido maxi asimétrico estampado

  const SIZE_RE = /^(talla|tamaño|tamano|size)\b/i;
  const clean = (value) => (value || '').trim();
  const scopeFor = (form) =>
    form.closest('product-information, .product-information, [data-product-information]') ||
    form.closest('section') ||
    form.parentElement;

  function getProductId(form) {
    return form.closest('product-form-component')?.dataset.productId;
  }

  function isRestrictedProduct(form) {
    return getProductId(form) === RESTRICTED_PRODUCT_ID;
  }

  function getSizeFields(form) {
    return [...scopeFor(form).querySelectorAll('fieldset')].filter((fieldset) =>
      SIZE_RE.test(clean(fieldset.querySelector('legend')?.textContent))
    );
  }

  // A fieldset counts as "selected" whether the option is a native radio
  // input or one of the Swatch King app's ARIA role="radio" swatch buttons.
  function isFieldsetSelected(fieldset) {
    if (fieldset.querySelector('input[type="radio"]:checked')) return true;
    if (fieldset.querySelector('[role="radio"][aria-checked="true"]')) return true;
    return false;
  }

  function getSizeField(form) {
    const fields = getSizeFields(form);
    return (
      fields.find((fieldset) => isFieldsetSelected(fieldset)) ||
      fields.find((fieldset) => fieldset.offsetParent !== null) ||
      fields[0]
    );
  }

  const hasSelection = (fieldset) => !fieldset || isFieldsetSelected(fieldset);

  function sync(form) {
    if (!isRestrictedProduct(form)) return;

    const fieldset = getSizeField(form);
    const canSubmit = hasSelection(fieldset);
    const scope = scopeFor(form);

    scope
      .querySelectorAll(
        'button[type="submit"], button[name="add"], .shopify-payment-button__button, [data-noave-buy-now]'
      )
      .forEach((button) => {
        if (!fieldset) return;
        button.disabled = !canSubmit;
        button.setAttribute('aria-disabled', canSubmit ? 'false' : 'true');
      });
  }

  async function buyNow(button) {
    const form =
      button.closest('form[action*="/cart/add"]') ||
      button.closest('product-form-component')?.querySelector('form[action*="/cart/add"]');

    if (!form) return;

    if (isRestrictedProduct(form)) {
      const fieldset = getSizeField(form);
      if (!hasSelection(fieldset)) {
        sync(form);
        return;
      }
    }

    const variantId =
      form.querySelector('[name="id"]')?.value ||
      new URL(window.location.href).searchParams.get('variant');
    if (!variantId) return;

    const originalText = button.textContent;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Procesando…';

    try {
      const root = window.Shopify?.routes?.root || '/';
      const formData = new FormData(form);
      formData.set('id', variantId);

      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        body: formData,
      });

      if (!response.ok) throw new Error('cart-add-failed');
      window.location.assign(`${root}checkout`);
    } catch (error) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = originalText;
      console.error('[NOAVE] Comprar ahora', error);
    }
  }

  function init(form) {
    // Only the restricted product forces a size choice before enabling the
    // buy buttons. Every other product's form is left completely untouched.
    if (!isRestrictedProduct(form)) return;

    const scope = scopeFor(form);
    const fields = getSizeFields(form);

    if (fields.length && scope.dataset.noaveSizeGuardCleared !== 'true') {
      fields.forEach((fieldset) =>
        fieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
          input.checked = false;
          input.removeAttribute('checked');
        })
      );
      scope.dataset.noaveSizeGuardCleared = 'true';
    }

    sync(form);
  }

  function run() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(init);
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-noave-buy-now]');
    if (!button) return;
    event.preventDefault();
    buyNow(button);
  });

  document.addEventListener('change', (event) => {
    const scope = event.target.closest(
      'product-information, .product-information, [data-product-information], section'
    );
    const form = scope?.querySelector('form[action*="/cart/add"]');
    if (form && isRestrictedProduct(form)) {
      sync(form);
      [0, 100, 500].forEach((delay) =>
        setTimeout(() => {
          const currentForm = scope.querySelector('form[action*="/cart/add"]');
          if (currentForm) sync(currentForm);
        }, delay)
      );
    }
  });

  // Swatch King's size options are clickable list items, not native inputs,
  // so a click on them doesn't always bubble a "change" event — listen for
  // clicks too, for the restricted product only.
  document.addEventListener('click', (event) => {
    const scope = event.target.closest(
      'product-information, .product-information, [data-product-information], section'
    );
    const form = scope?.querySelector('form[action*="/cart/add"]');
    if (form && isRestrictedProduct(form)) {
      setTimeout(() => sync(form), 0);
    }
  });

  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
  setTimeout(run, 700);
})();
